import React from 'react'
import { Button, createStyles, Grid, makeStyles, Typography } from '@material-ui/core';
import DialpadIcon from '@material-ui/icons/Dialpad';
import { InputAdornment } from '@material-ui/core';
import { TextField } from '@material-ui/core';
// import { RegisterService } from '../services/RegisterService';
import { useTranslation } from 'react-i18next'
import Spin from '../../images/Spin';
import { colors } from '../../styles/defaultColors';
import { Error } from '@material-ui/icons';

const useStyles = makeStyles((theme) =>
  createStyles({
    button: {
        // width: "100%",
        background: "#890608",
        color: "white",
        borderRadius: 100,
        fontFamily: "Josefin Sans",
        fontSize: 14,
        textTransform: "none",
        padding: "8px 14px",
        marginBottom:25,
        width: 175,
        "&:hover": {
            background: "#B5551B",
        },
    },
    inputForm: {
      display: "flex",
      marginBottom: theme.spacing(2),
    },
    forgotPassword: {
      textAlign: "right",
      textDecoration: "none",
      marginBottom: theme.spacing(2),
    },
    register: {
      display: "flex",
      alignItems: "center",
      justifyContent: "end",
    },
    buttons: {
      marginBottom: theme.spacing(2),
    },
    textField: {
        "&::placeholder": {
            color: "#000",
        },
        marginTop: 15,
        marginBottom: 15,
    },
    loginButton: {
      width: "150px",
      background: "linear-gradient(to right, #877979, #af9b9b);",
      color: "white",
      borderRadius: "50px",
      textTransform: "capitalize",
    },
    icon: {
      position: "relative",
      top: 0,
    },   
    titlForm:{
        fontFamily: "Josefin Sans",
        fontSize: 20,
        marginBottom: 20,
        color: '#890608',
        display: 'block'

    },
    spanProfil: {
        fontFamily: "Josefin Sans",
        fontSize: 14,
        marginBottom: 20,
        display: 'block'
    },
    errors: {
        color: colors.danger,
        background: colors.backgroundDanger,
        width: "100%",
        textAlign: "center",
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
        borderRadius: 5,
        "& p": {
            padding: 10,
        },
    },
    input: {
      "&::placeholder": {
        textOverflow: "ellipsis !important",
        color: "#000000",
        opacity: 10,
      },
    },
  })
);


export const GlobalValidationOTP = ({errorMessages, validationCodeEntered, setValidationCodeEntered, validationCodeData, handleValidationOTP, loadingValidation}: {errorMessages:string, validationCodeEntered:number | null, setValidationCodeEntered:(val:number)=>void, validationCodeData: any, handleValidationOTP: ()=>void, loadingValidation: boolean}) => {

    const classes= useStyles();
    const { t } = useTranslation()

    return (
        <Grid item container lg={12} md={12} sm={12} xs={12}>
            <Grid container spacing={3} direction="row">
                <Grid item lg={12} md={12} sm={12} xs={12} style={{textAlign: 'center'}}>
                    <span className={classes.titlForm}>{t('label.validation-otp')}</span>
                    <span className={classes.spanProfil}>{`${t('label.un-code-de-validation-a-ete-envoye')} ${validationCodeData.codePhone} ${validationCodeData.userPhone}`}</span>
                    <div className={classes.inputForm}>
                        <TextField
                            autoFocus
                            margin="dense"
                            id="validationCode"
                            required
                            variant='outlined'
                            name="validationCode"
                            type="number"
                            fullWidth
                            label={t('label.entrer-le-code')}
                            classes={{root: classes.textField}}
                            onChange={e=>setValidationCodeEntered(parseInt(e.target.value))}
                            value={validationCodeEntered || null}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <DialpadIcon
                                            className={classes.icon}
                                        />
                                    </InputAdornment>
                                ),
                                classes: {input: classes["input"]},
                            }}
                        />
                    </div>
                  
                    {errorMessages && (
                        <div className={classes.errors} style={{ marginBottom: 50, marginTop: 0 }}>
                            <Typography>
                                <Error />
                                <br />
                                <span>{errorMessages}</span>
                            </Typography>
                        </div>
                    )}
                </Grid>
                
                <Button
                    size="small"
                    type={"button"}
                    className={classes.button}
                    style={{ display: 'block', marginLeft: 'auto', marginRight: 'auto' }}
                    endIcon={loadingValidation ? <Spin /> : null}
                    disabled={loadingValidation }
                    onClick={ handleValidationOTP}
                >
                  Confirmer
                </Button>
            </Grid>
        </Grid>
    )
}
